import styled, { css } from "styled-components";
import { KOGTableRow } from "@/main/components/shared/boxGrid/styles";
import { KOGMediaQuery } from "@/main/services/utilsLayout";

export const Container = styled(KOGTableRow)`
	&&& {
		.MuiIconButton-root.Mui-disabled {
			color: rgba(0, 0, 0, 0.34);
		}
	}
`;

export const CustomColumn = styled.div`
	width: 100%;
	max-width: 100%;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;

	${({ theme }) =>
		KOGMediaQuery({
			breakpoint: theme.breakpoints.desktop,
			styles: css`
				max-width: 200px;
			`,
		})}
`;
